<style>
  .all {
    /* TODO: MODAA KUN https://github.com/angular/material2/issues/8493 on korjattu */
    max-height: 95vh;
  }
</style>
<div class="all" [class.iso]="!cellphone()" mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  @if (!cellphone()) {
    <mat-horizontal-stepper [linear]="true" [@.disabled]="true" #horizStepper>
      <mat-step [label]="'start'" [editable]="false">
        <ng-template matStepLabel>{{ 'yleiset.tervetuloa' | translate | async }}</ng-template>
        <div class="teksti">
          <div class="light-blue-text otsikko">{{ 'yleiset.tervetuloa' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          @if (commonError()) {
            <div class="lemon-error">{{ commonError() }}</div>
          }
          <div class="dynamic-spacer"></div>
          <div class="teksti-big">{{ 'lemonaid-sopimus-dialog.valmis-kaytettavaksi' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div>{{ 'lemonaid-sopimus-dialog.ennen-aloittamista' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div class="button-container">
            <button class="primarybutton" mat-button matStepperNext>{{ 'yleiset.jatka' | translate | async }}</button>
          </div>
        </div>
      </mat-step>
      @if (naytaTunnistaminen) {
        <mat-step [label]="'tunnistaminen'" [editable]="false" [completed]="strongAuthResult === 'success' && tunnistautujanTiedotAnnettu()">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)">
              {{ 'lemonaid-sopimus-dialog.tunnistaminen' | translate | async }}
            </div>
          </ng-template>
          <div class="teksti">
            <div class="light-blue-text otsikko" [innerHtml]="'lemonaid-sopimus-dialog.asiakkaan-tunnistaminen' | translate | async"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            @if (strongAuthResult === 'start' || strongAuthResult === 'error' || strongAuthResult === 'error-cancel') {
              <div [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-tunnistamaan' | translate | async"></div>
              <div class="dynamic-spacer"></div>
              @if (strongAuthResult === 'start') {
                <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistaudu-pankkitunnuksilla' | translate | async"></div>
              }
              @if (strongAuthResult === 'error' || strongAuthResult === 'error-cancel') {
                <div class="lemon-error" [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-epaonnistui' | translate | async"></div>
              }
              <div class="dynamic-spacer"></div>
              @if (commonError()) {
                <div class="lemon-error">{{ commonError() }}</div>
              }
              <div class="dynamic-spacer"></div>
              <div tunnistautuminen-nets-pankit [actionAfterSuccess]="'continue-welcome'" [kieli]="kieli()"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
            }
            @if (strongAuthResult === 'success') {
              @if (!tunnistautujanTiedotAnnettu()) {
                <div [innerHtml]="'lemonaid-sopimus-dialog.anna-lisatiedot' | translate | async"></div>
                <form class="tunnistautuja">
                  <mat-form-field class="tunnistautuja-short">
                    <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                    <input type="text" [formField]="tunnistautujaLomake.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                  </mat-form-field>
                  <mat-form-field class="tunnistautuja-short" style="margin: 0 25px">
                    <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                    <mat-select [formField]="tunnistautujaLomake.kansallisuus">
                      @for (kansa of kansallisuudetObservable | async; track kansa) {
                        <mat-option [value]="kansa.koodi">
                          {{ kansa.nimi }}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-error>
                      @if (tunnistautujaLomake.kansallisuus; as n) {
                        @if (n().touched()) {
                          @if (onkoVirhe(n, 'required')) {
                            {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                          }
                        }
                      }
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="tunnistautuja-long">
                    <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                    <mat-select [formField]="tunnistautujaLomake.pep">
                      <mat-option [value]="true">
                        {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                      </mat-option>
                      <mat-option [value]="false">
                        {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      @if (tunnistautujaLomake.pep; as n) {
                        @if (n().touched()) {
                          @if (onkoVirhe(n, 'required')) {
                            {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                          }
                        }
                      }
                    </mat-error>
                  </mat-form-field>
                </form>
                <div class="form-comment-container">
                  <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                </div>
                <div class="dynamic-spacer"></div>
                <div style="font-weight: bold">{{ 'lemonaid-sopimus-dialog.kyc.pep-miksi-kerataan' | translate | async }}</div>
                <div class="dynamic-spacer"></div>
                <div style="margin: 0 auto; width: 85%">{{ 'lemonaid-sopimus-dialog.kyc.pep-naita-tuntemistietoja' | translate | async }}</div>
                <div class="dynamic-spacer"></div>
                <div class="dynamic-spacer"></div>
                @if (commonError()) {
                  <div class="lemon-error">{{ commonError() }}</div>
                }
                <div class="button-container">
                  <button (click)="tallennaTunnistautujaLisatiedot()" class="primarybutton" mat-button>{{ 'yleiset.jatka' | translate | async }}</button>
                </div>
              }
              @if (tunnistautujanTiedotAnnettu()) {
                <div class="dynamic-spacer"></div>
                <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-onnistui' | translate | async"></div>
                <div class="dynamic-spacer"></div>
                <div class="button-container">
                  <button class="primarybutton" mat-button matStepperNext>{{ 'yleiset.jatka' | translate | async }}</button>
                </div>
                <div class="dynamic-spacer"></div>
              }
            }
          </div>
        </mat-step>
      }
      @if (naytaSopimus) {
        <mat-step [stepControl]="sopimusLomake" [editable]="false" [label]="'sopimus'">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)">
              {{ 'lemonaid-sopimus-dialog.toimeksiantosopimus-nonbreak' | translate | async }}
            </div>
          </ng-template>
          <form #sopimusForm="ngForm" class="teksti side-margins" style="text-align: left">
            <div class="dynamic-spacer"></div>
            <div class="light-blue-text otsikko" [innerHtml]="'lemonaid-sopimus-dialog.toimeksiantosopimus-break' | translate | async"></div>
            <div class="dynamic-spacer"></div>
            @if (commonError()) {
              <div class="lemon-error">{{ commonError() }}</div>
            }
            <div class="dynamic-spacer"></div>
            <div>{{ 'lemonaid-sopimus-dialog.palvelumme-sisaltaa' | translate | async }}</div>
            <div class="dynamic-spacer-puolet"></div>
            <div>{{ 'lemonaid-sopimus-dialog.lue-tarkempi-erittely' | translate | async }}</div>
            <div class="dynamic-spacer"></div>
            <app-palvelukokonaisuus [sopimuskausi]="sopimuskaudenVersio" [isOnboarding]="true"></app-palvelukokonaisuus>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>

            @if (hintaPalvelunAlkaessaObservable | async; as hinta) {
              <div>
                <div class="price-text">
                  {{ 'lemonaid-sopimus-dialog.kuukausihinta-alkaessa' | translate | async }}: <span class="light-blue-text otsikko-numero">{{ hinta }} /{{ 'lemonaid-sopimus-dialog.kuukaudessa' | translate | async }}</span>
                </div>
                <div class="dynamic-spacer"></div>
                @if (ensimmainenLaskutettavaKuukausi) {
                  <div class="price-text">
                    {{ 'lemonaid-sopimus-dialog.ensimmainen-kuukausi' | translate | async }}: <span class="light-blue-text otsikko-numero">{{ ensimmainenLaskutettavaKuukausi }}</span>
                  </div>
                }
                <div class="dynamic-spacer"></div>
                <div class="teksti-small">{{ 'lemonaid-sopimus-dialog.aiempiin-laskutetaan-tuntiperusteisesti' | translate | async }}</div>

                <div class="dynamic-spacer"></div>
                <div class="dynamic-spacer"></div>
              </div>
            }

            @if (viewableMuutJatkuvatVeloitukset()?.length) {
              <div>
                @if (hintaPalvelunAlkaessaObservable | async) {
                  <div class="price-text">{{ 'lemonaid-sopimus-dialog.muut-jatkuvat-veloitukset' | translate | async }}:</div>
                }
                @for (veloitus of viewableMuutJatkuvatVeloitukset(); track veloitus) {
                  <div class="veloitus-row">
                    <div>{{ veloitus.nimi }}:</div>
                    <div>
                      <span class="light-blue-text" style="font-weight: 600">{{ veloitus.hinta | currency: '€' }}</span
                      ><span class="veloitus-frekvenssi"> / {{ veloitus.frekvenssi }}</span>
                    </div>
                  </div>
                }
              </div>
            }

            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer-puolet"></div>
            <!-- <mat-checkbox formControlName="hyvaksy">{{'lemonaid-sopimus-dialog.lukenut-ja-hyvaksyn' | translate | async }}:</mat-checkbox> -->
            <mat-checkbox [formField]="sopimusLomake.hyvaksy" [class.mat-form-field-invalid]="onkoVirhe(hyvaksy, 'required') && hyvaksy().dirty()">{{ 'lemonaid-sopimus-dialog.lukenut-ja-hyvaksyn' | translate | async }}:</mat-checkbox>
            <div class="lataa-pdf-container">
              <button (click)="downloadSopimusPreview()" mat-button>
                <mat-icon class="mat-24">download</mat-icon>
                <span>{{ 'muutoksia-palveluun.toimeksiantosopimus' | translate | async }}</span>
              </button>
              @for (liitetyyppi of liitetyypit; track liitetyyppi) {
                <button (click)="downloadLiite(liitetyyppi)" mat-button>
                  <mat-icon class="mat-24">download</mat-icon>
                  <span>{{ liiteNimet[liitetyyppi] | translate | async }}</span>
                </button>
              }
            </div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="button-container">
              <button class="primarybutton" mat-button (click)="tallennaHyvaksynta()">{{ 'lemonaid-sopimus-dialog.hyvaksy-ja-jatka' | translate | async }}</button>
            </div>
          </form>
        </mat-step>
      }
      @if (naytaTuntemistiedot) {
        <mat-step [stepControl]="tuntemistiedotLomake" [editable]="false" [label]="'tuntemistiedot'">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)">
              {{ 'lemonaid-sopimus-dialog.tuntemistiedot' | translate | async }}
            </div>
          </ng-template>
          <form #tunnistamisForm="ngForm" class="teksti tunnistamistiedot">
            <div class="kyc">
              <div class="light-blue-text otsikko">
                {{ 'lemonaid-sopimus-dialog.kyc.yhtion-tunteminen' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div style="text-align: center" [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-keramaan' | translate | async"></div>
              <div class="dynamic-spacer"></div>
              @if (commonError()) {
                <div class="lemon-error">{{ commonError() }}</div>
              }
              <div class="dynamic-spacer"></div>
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.osakkaat' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-osakkeiden-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              @if (onkoVirhe(osakasRivit, 'min')) {
                <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-osakas' | translate | async }}</div>
              }
              <div>
                @for (osakasRivi of osakasRivit; track osakasRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-large">
                      <mat-checkbox [labelPosition]="'before'" [formField]="osakasRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <mat-radio-group class="kyc-radio" [formField]="osakasRivi.onkoYritys" [style.display]="osakasRivi.onkoYritys().disabled() ? 'none' : 'flex'">
                      <mat-radio-button style="margin: 5px" [value]="false">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-luonnollinen' | translate | async }}</mat-radio-button>
                      <mat-radio-button style="margin: 5px" [value]="true">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-yritys' | translate | async }}</mat-radio-button>
                    </mat-radio-group>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                        <input type="text" [formField]="osakasRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (osakasRivi.nimi; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus' | translate | async }}</mat-label>
                        <input type="text" [formField]="osakasRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (osakasRivi.hetu; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-required' | translate | async }}
                              }
                              @if (onkoVirhe(n, 'invalid')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-invalid' | translate | async }}
                              }
                              @if (onkoVirhe(n, 'ownytunnus')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.oma-ytunnus' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="right-margin-in-large-view" [style.display]="osakasRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                        <input type="text" [matDatepicker]="picker1" [formField]="osakasRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-error>
                          @if (osakasRivi.birthDate; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-datepicker #picker1></mat-datepicker>
                      <mat-form-field>
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara' | translate | async }}</mat-label>
                        <input decimalNumberField matInput [formField]="osakasRivi.osakkeita" [numberOfDecimals]="0" autocomplete="nothing" data-lpignore="true" />
                        <mat-error>
                          @if (osakasRivi.osakkeita; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara-puuttuu' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                        <mat-select [formField]="osakasRivi.kansallisuus">
                          @for (kansa of kansallisuudetObservable | async; track kansa) {
                            <mat-option [value]="kansa.koodi">
                              {{ kansa.nimi }}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-error>
                          @if (osakasRivi.kansallisuus; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                        <mat-select [formField]="osakasRivi.pep">
                          <mat-option [value]="true">
                            {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                          </mat-option>
                          <mat-option [value]="false">
                            {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          @if (osakasRivi.pep; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaOsakas(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaOsakas(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-osakas' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.hallitus-ja-toimitusjohtaja' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-paattajien-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              @if (onkoVirhe(hallitusRivit, 'min')) {
                <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-hallituksen-jasenen' | translate | async }}</div>
              }
              <div>
                @for (jasenRivi of hallitusRivit; track jasenRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-large">
                      <mat-checkbox [labelPosition]="'before'" [formField]="jasenRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                        <input type="text" [formField]="jasenRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (jasenRivi.nimi; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                        <input type="text" [formField]="jasenRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (jasenRivi.hetu; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                              }
                              @if (onkoVirhe(n, 'invalid')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="right-margin-in-large-view" [style.display]="jasenRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                        <input type="text" [matDatepicker]="picker2" [formField]="jasenRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-error>
                          @if (jasenRivi.birthDate; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-datepicker #picker2></mat-datepicker>
                      <mat-form-field>
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.rooli' | translate | async }}</mat-label>
                        <mat-select [formField]="jasenRivi.rooli">
                          @for (rooli of hallitusRoolitObservable | async; track rooli) {
                            <mat-option [value]="rooli.avain">
                              {{ rooli.nimi }}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-error>
                          @if (jasenRivi.rooli; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.rooli-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                        <mat-select [formField]="jasenRivi.kansallisuus">
                          @for (kansa of kansallisuudetObservable | async; track kansa) {
                            <mat-option [value]="kansa.koodi">
                              {{ kansa.nimi }}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-error>
                          @if (jasenRivi.kansallisuus; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                        <mat-select [formField]="jasenRivi.pep">
                          <mat-option [value]="true">
                            {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                          </mat-option>
                          <mat-option [value]="false">
                            {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          @if (jasenRivi.pep; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaHallituksenJasen(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaHallituksenJasen(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-jasen' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.edunsaajat' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.edunsaajien-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <!-- <div class="dynamic-spacer"></div> -->
              <div>
                @for (saajaRivi of edunsaajaRivit; track saajaRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-large">
                      <mat-checkbox [labelPosition]="'before'" [formField]="saajaRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                        <input type="text" [formField]="saajaRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (saajaRivi.nimi; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                        <input type="text" [formField]="saajaRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-error>
                          @if (saajaRivi.hetu; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                              }
                              @if (onkoVirhe(n, 'invalid')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                              }
                              @if (onkoVirhe(n, 'ownytunnus')) {}
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field class="margined-text-row-in-large-view" [style.display]="saajaRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                        <input type="text" [matDatepicker]="picker3" [formField]="saajaRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                        <mat-error>
                          @if (saajaRivi.birthDate; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-datepicker #picker3></mat-datepicker>
                    </div>
                    <div class="kyc-single-row">
                      <mat-form-field class="right-margin-in-large-view">
                        <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                        <mat-select [formField]="saajaRivi.kansallisuus">
                          @for (kansa of kansallisuudetObservable | async; track kansa) {
                            <mat-option [value]="kansa.koodi">
                              {{ kansa.nimi }}
                            </mat-option>
                          }
                        </mat-select>
                        <mat-error>
                          @if (saajaRivi.kansallisuus; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                        <mat-select [formField]="saajaRivi.pep">
                          <mat-option [value]="true">
                            {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                          </mat-option>
                          <mat-option [value]="false">
                            {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                          </mat-option>
                        </mat-select>
                        <mat-error>
                          @if (saajaRivi.pep; as n) {
                            @if (n().touched() || tunnistamisForm.submitted) {
                              @if (onkoVirhe(n, 'required')) {
                                {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                              }
                            }
                          }
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaEdunsaaja(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaEdunsaaja(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-edunsaaja' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div>
                <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
                {{ 'lemonaid-sopimus-dialog.kyc.edunsaajalla-tarkoitetaan' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div style="font-weight: bold">{{ 'lemonaid-sopimus-dialog.kyc.miksi-tietoja-kerataan' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>
                <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
                {{ 'lemonaid-sopimus-dialog.kyc.naita-tuntemistietoja' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div>
                {{ 'lemonaid-sopimus-dialog.kyc.jos-muutoksia' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
            </div>
            <div class="button-container">
              <button class="primarybutton" mat-button (click)="tallennaKyc()">{{ 'yleiset.jatka' | translate | async }}</button>
            </div>
          </form>
        </mat-step>
      }
      <mat-step [label]="'valmis'">
        <ng-template matStepLabel>
          <div (click)="saveCurrentStep($event)">
            {{ 'yleiset.valmis' | translate | async }}
          </div>
        </ng-template>
        <div class="teksti">
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <svg style="height: calc(76px + 1vw)" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 22 22" fill="rgb(62, 203, 244)">
            <path d="M15 25.62A10.62 10.62 0 1 1 25.62 15 10.63 10.63 0 0 1 15 25.62ZM15 5.23A9.77 9.77 0 1 0 24.77 15 9.78 9.78 0 0 0 15 5.23Z"></path>
            <rect x="13.26" y="10.91" width="0.85" height="2.93"></rect>
            <rect x="15.89" y="10.91" width="0.85" height="2.93"></rect>
            <path d="M15 20.08a3.22 3.22 0 0 1-3.22-3.22h0.85a2.37 2.37 0 1 0 4.74 0h0.85A3.22 3.22 0 0 1 15 20.08Z"></path>
          </svg>
          <div class="light-blue-text otsikko">{{ 'yleiset.valmista' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          @if (commonError()) {
            <div class="lemon-error">{{ commonError() }}</div>
          }
          <div class="dynamic-spacer"></div>
          <div class="teksti-big">{{ 'lemonaid-sopimus-dialog.sopimus-hyvaksytty' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div class="button-container">
            <!-- <button class="secondarybutton" mat-button matStepperPrevious>Takaisin</button> -->
            <button class="primarybutton" mat-button (click)="valmis()">{{ 'yleiset.ok' | translate | async }}</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  }

  @if (cellphone()) {
    <mat-vertical-stepper [linear]="true" #verticStepper>
      <mat-step [label]="'start'" [editable]="false">
        <ng-template matStepLabel>
          {{ 'yleiset.tervetuloa' | translate | async }}
        </ng-template>
        <div class="teksti">
          <div class="light-blue-text otsikko">{{ 'yleiset.tervetuloa' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          @if (commonError()) {
            <div class="lemon-error">{{ commonError() }}</div>
          }
          <div class="dynamic-spacer"></div>
          <div class="teksti-big">{{ 'lemonaid-sopimus-dialog.valmis-kaytettavaksi' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div>{{ 'lemonaid-sopimus-dialog.ennen-aloittamista' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div class="button-container">
            <button class="primarybutton" mat-button matStepperNext>{{ 'yleiset.jatka' | translate | async }}</button>
          </div>
        </div>
      </mat-step>
      @if (naytaTunnistaminen) {
        <mat-step [label]="'tunnistaminen'" [editable]="false" [completed]="strongAuthResult === 'success' && tunnistautujanTiedotAnnettu()">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)">
              {{ 'lemonaid-sopimus-dialog.tunnistaminen' | translate | async }}
            </div>
          </ng-template>
          <div class="teksti">
            <div class="light-blue-text otsikko" [innerHtml]="'lemonaid-sopimus-dialog.asiakkaan-tunnistaminen' | translate | async"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            @if (strongAuthResult === 'start' || strongAuthResult === 'error' || strongAuthResult === 'error-cancel') {
              <div [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-tunnistamaan' | translate | async"></div>
              <div class="dynamic-spacer"></div>
              @if (strongAuthResult === 'start') {
                <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistaudu-pankkitunnuksilla' | translate | async"></div>
              }
              @if (strongAuthResult === 'error' || strongAuthResult === 'error-cancel') {
                <div class="lemon-error" [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-epaonnistui' | translate | async"></div>
              }
              <div class="dynamic-spacer"></div>
              @if (commonError()) {
                <div class="lemon-error">{{ commonError() }}</div>
              }
              <div class="dynamic-spacer"></div>
              <div tunnistautuminen-nets-pankit [actionAfterSuccess]="'continue-welcome'" [kieli]="kieli()"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
            }
            @if (strongAuthResult === 'success') {
              @if (!tunnistautujanTiedotAnnettu()) {
                <div [innerHtml]="'lemonaid-sopimus-dialog.anna-lisatiedot' | translate | async"></div>
                <div class="dynamic-spacer"></div>
                <form class="tunnistautuja">
                  <mat-form-field>
                    <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                    <input type="text" [formField]="tunnistautujaLomake.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                    <mat-select [formField]="tunnistautujaLomake.kansallisuus">
                      @for (kansa of kansallisuudetObservable | async; track kansa) {
                        <mat-option [value]="kansa.koodi">
                          {{ kansa.nimi }}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-error>
                      @if (tunnistautujaLomake.kansallisuus; as n) {
                        @if (n().touched() && n().dirty()) {
                          @if (onkoVirhe(n, 'required')) {
                            {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                          }
                        }
                      }
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                    <mat-select [formField]="tunnistautujaLomake.pep">
                      <mat-option [value]="true">
                        {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                      </mat-option>
                      <mat-option [value]="false">
                        {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      @if (tunnistautujaLomake.pep; as n) {
                        @if (n().touched() && n().dirty()) {
                          @if (onkoVirhe(n, 'required')) {
                            {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                          }
                        }
                      }
                    </mat-error>
                  </mat-form-field>
                </form>
                <div class="form-comment-container">
                  <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                </div>
                <div class="dynamic-spacer"></div>
                <div class="dynamic-spacer"></div>
                <div style="font-weight: bold; text-align: left">{{ 'lemonaid-sopimus-dialog.kyc.pep-miksi-kerataan' | translate | async }}</div>
                <div class="dynamic-spacer"></div>
                <div style="text-align: left">{{ 'lemonaid-sopimus-dialog.kyc.pep-naita-tuntemistietoja' | translate | async }}</div>
                <div class="dynamic-spacer"></div>
                <div class="dynamic-spacer"></div>
                @if (commonError()) {
                  <div class="lemon-error">{{ commonError() }}</div>
                }
                <div class="button-container">
                  <button (click)="tallennaTunnistautujaLisatiedot()" class="primarybutton" mat-button>{{ 'yleiset.jatka' | translate | async }}</button>
                </div>
                <div class="dynamic-spacer"></div>
              }
              @if (tunnistautujanTiedotAnnettu()) {
                <div [innerHtml]="'lemonaid-sopimus-dialog.tunnistautuminen-onnistui' | translate | async"></div>
                <div class="dynamic-spacer"></div>
                <div class="button-container">
                  <button class="primarybutton" mat-button matStepperNext>{{ 'yleiset.jatka' | translate | async }}</button>
                </div>
                <div class="dynamic-spacer"></div>
              }
            }
          </div>
        </mat-step>
      }
      @if (naytaSopimus) {
        <mat-step [stepControl]="sopimusLomake" [editable]="false" [label]="'sopimus'">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)" [innerHtml]="'lemonaid-sopimus-dialog.toimeksiantosopimus-break' | translate | async"></div>
          </ng-template>
          <form #sopimusForm="ngForm" class="teksti" style="text-align: left">
            <div class="dynamic-spacer"></div>
            <div class="light-blue-text otsikko" [innerHtml]="'lemonaid-sopimus-dialog.toimeksiantosopimus-break' | translate | async"></div>
            <div class="dynamic-spacer"></div>
            @if (commonError()) {
              <div class="lemon-error">{{ commonError() }}</div>
            }
            <div class="dynamic-spacer"></div>
            <div>{{ 'lemonaid-sopimus-dialog.palvelumme-sisaltaa' | translate | async }}</div>
            <div class="dynamic-spacer-puolet"></div>
            <div>{{ 'lemonaid-sopimus-dialog.lue-tarkempi-erittely' | translate | async }}</div>
            <div class="dynamic-spacer"></div>
            <app-palvelukokonaisuus [sopimuskausi]="sopimuskaudenVersio"></app-palvelukokonaisuus>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="price-text">
              {{ 'lemonaid-sopimus-dialog.kuukausihinta-alkaessa' | translate | async }}: <span class="light-blue-text otsikko-numero" style="vertical-align: middle; padding: 0 2vw">{{ hintaPalvelunAlkaessaObservable | async }} /{{ 'lemonaid-sopimus-dialog.kuukaudessa' | translate | async }}</span>
            </div>
            <div class="dynamic-spacer"></div>
            <div class="price-text">
              {{ 'lemonaid-sopimus-dialog.ensimmainen-kuukausi' | translate | async }}: <span class="light-blue-text otsikko-numero" style="vertical-align: middle; padding: 0 2vw">{{ ensimmainenLaskutettavaKuukausi }}</span>
            </div>
            <div class="dynamic-spacer"></div>
            <div class="teksti-small">{{ 'lemonaid-sopimus-dialog.aiempiin-laskutetaan-tuntiperusteisesti' | translate | async }}</div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div style="text-align: left">
              <div></div>
              <div class="dynamic-spacer-puolet"></div>
              <!-- <mat-checkbox formControlName="hyvaksy" class="pitka-label">{{'lemonaid-sopimus-dialog.lukenut-ja-hyvaksyn' | translate | async }}:</mat-checkbox> -->
              <mat-checkbox [formField]="sopimusLomake.hyvaksy" class="pitka-label" [class.mat-form-field-invalid]="onkoVirhe(hyvaksy, 'required') && hyvaksy().touched()">{{ 'lemonaid-sopimus-dialog.lukenut-ja-hyvaksyn' | translate | async }}:</mat-checkbox>
              <div class="lataa-pdf-container">
                <button (click)="downloadSopimusPreview()" mat-button>
                  <mat-icon class="mat-24">download</mat-icon>
                  <span>{{ 'muutoksia-palveluun.toimeksiantosopimus' | translate | async }}</span>
                </button>
                @for (liitetyyppi of liitetyypit; track liitetyyppi) {
                  <button (click)="downloadLiite(liitetyyppi)" mat-button>
                    <mat-icon class="mat-24">download</mat-icon>
                    <span>{{ liiteNimet[liitetyyppi] | translate | async }}</span>
                  </button>
                }
              </div>
            </div>
            <div class="dynamic-spacer"></div>
            <div class="dynamic-spacer"></div>
            <div class="button-container">
              <button class="primarybutton" mat-button (click)="tallennaHyvaksynta()">{{ 'lemonaid-sopimus-dialog.hyvaksy-ja-jatka' | translate | async }}</button>
            </div>
          </form>
        </mat-step>
      }
      @if (naytaTuntemistiedot) {
        <mat-step [stepControl]="tuntemistiedotLomake" [editable]="false" [label]="'tuntemistiedot'">
          <ng-template matStepLabel>
            <div (click)="saveCurrentStep($event)">
              {{ 'lemonaid-sopimus-dialog.tuntemistiedot' | translate | async }}
            </div>
          </ng-template>
          <form #tunnistamisForm="ngForm" class="teksti tunnistamistiedot">
            <div class="kyc">
              <div class="light-blue-text otsikko">
                {{ 'lemonaid-sopimus-dialog.kyc.yhtion-tunteminen' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div style="text-align: center" [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-keramaan' | translate | async"></div>
              <div class="dynamic-spacer"></div>
              @if (commonError()) {
                <div class="lemon-error">{{ commonError() }}</div>
              }
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.osakkaat' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-osakkeiden-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              @if (onkoVirhe(osakasRivit, 'min')) {
                <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-osakas' | translate | async }}</div>
              }
              <div>
                @for (osakasRivi of osakasRivit; track osakasRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-cellphone">
                      <mat-checkbox [labelPosition]="'before'" [formField]="osakasRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                      <input type="text" [formField]="osakasRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (osakasRivi.nimi; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus' | translate | async }}</mat-label>
                      <input type="text" [formField]="osakasRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (osakasRivi.hetu; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-required' | translate | async }}
                            }
                            @if (onkoVirhe(n, 'invalid')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-invalid' | translate | async }}
                            }
                            @if (onkoVirhe(n, 'ownytunnus')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.oma-ytunnus' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field [style.display]="osakasRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                      <input type="text" [matDatepicker]="picker1" [formField]="osakasRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-error>
                        @if (osakasRivi.birthDate; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-datepicker #picker1></mat-datepicker>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara' | translate | async }}</mat-label>
                      <input decimalNumberField matInput [formField]="osakasRivi.osakkeita" [numberOfDecimals]="0" autocomplete="nothing" data-lpignore="true" />
                      <mat-error>
                        @if (osakasRivi.osakkeita; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara-puuttuu' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                      <mat-select [formField]="osakasRivi.kansallisuus">
                        @for (kansa of kansallisuudetObservable | async; track kansa) {
                          <mat-option [value]="kansa.koodi">
                            {{ kansa.nimi }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        @if (osakasRivi.kansallisuus; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                      <mat-select [formField]="osakasRivi.pep">
                        <mat-option [value]="true">
                          {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                        </mat-option>
                        <mat-option [value]="false">
                          {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                        </mat-option>
                      </mat-select>
                      <mat-error>
                        @if (osakasRivi.pep; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaOsakas(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaOsakas(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-osakas' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.hallitus-ja-toimitusjohtaja' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-paattajien-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              @if (onkoVirhe(hallitusRivit, 'min')) {
                <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-hallituksen-jasenen' | translate | async }}</div>
              }
              <div>
                @for (jasenRivi of hallitusRivit; track jasenRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-cellphone">
                      <mat-checkbox [labelPosition]="'before'" [formField]="jasenRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                      <input type="text" [formField]="jasenRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (jasenRivi.nimi; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                      <input type="text" [formField]="jasenRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (jasenRivi.hetu; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                            }
                            @if (onkoVirhe(n, 'invalid')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field [style.display]="jasenRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                      <input type="text" [matDatepicker]="picker2" [formField]="jasenRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-error>
                        @if (jasenRivi.birthDate; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-datepicker #picker2></mat-datepicker>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.rooli' | translate | async }}</mat-label>
                      <mat-select [formField]="jasenRivi.rooli">
                        @for (rooli of hallitusRoolitObservable | async; track rooli) {
                          <mat-option [value]="rooli.avain">
                            {{ rooli.nimi }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        @if (jasenRivi.rooli; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.rooli-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                      <mat-select [formField]="jasenRivi.kansallisuus">
                        @for (kansa of kansallisuudetObservable | async; track kansa) {
                          <mat-option [value]="kansa.koodi">
                            {{ kansa.nimi }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        @if (jasenRivi.kansallisuus; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                      <mat-select [formField]="jasenRivi.pep">
                        <mat-option [value]="true">
                          {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                        </mat-option>
                        <mat-option [value]="false">
                          {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                        </mat-option>
                      </mat-select>
                      <mat-error>
                        @if (jasenRivi.pep; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaHallituksenJasen(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaHallituksenJasen(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-jasen' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.edunsaajat' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>{{ 'lemonaid-sopimus-dialog.kyc.edunsaajien-tiedot' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <!-- <div class="dynamic-spacer"></div> -->
              <div>
                @for (saajaRivi of edunsaajaRivit; track saajaRivi; let i = $index) {
                  <div class="kyc-item">
                    <div class="kyc-checkbox-cellphone">
                      <mat-checkbox [labelPosition]="'before'" [formField]="saajaRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
                    </div>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                      <input type="text" [formField]="saajaRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (saajaRivi.nimi; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                      <input type="text" [formField]="saajaRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-error>
                        @if (saajaRivi.hetu; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                            }
                            @if (onkoVirhe(n, 'invalid')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field [style.display]="saajaRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                      <input type="text" [matDatepicker]="picker3" [formField]="saajaRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                      <mat-error>
                        @if (saajaRivi.birthDate; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-datepicker #picker3></mat-datepicker>
                    <mat-form-field>
                      <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                      <mat-select [formField]="saajaRivi.kansallisuus">
                        @for (kansa of kansallisuudetObservable | async; track kansa) {
                          <mat-option [value]="kansa.koodi">
                            {{ kansa.nimi }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        @if (saajaRivi.kansallisuus; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                      <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                      <mat-select [formField]="saajaRivi.pep">
                        <mat-option [value]="true">
                          {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                        </mat-option>
                        <mat-option [value]="false">
                          {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                        </mat-option>
                      </mat-select>
                      <mat-error>
                        @if (saajaRivi.pep; as n) {
                          @if (n().touched() || tunnistamisForm.submitted) {
                            @if (onkoVirhe(n, 'required')) {
                              {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                            }
                          }
                        }
                      </mat-error>
                    </mat-form-field>
                    <div class="form-comment-container">
                      <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
                    </div>
                    <button mat-icon-button (click)="poistaEdunsaaja(i); $event.preventDefault()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                }
                <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaEdunsaaja(); $event.preventDefault()">
                  <!-- {{'yleiset.jatka' | translate | async }} -->
                  {{ 'lemonaid-sopimus-dialog.kyc.lisaa-edunsaaja' | translate | async }}
                </button>
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div>
                <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
                {{ 'lemonaid-sopimus-dialog.kyc.edunsaajalla-tarkoitetaan' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div style="font-weight: bold">{{ 'lemonaid-sopimus-dialog.kyc.miksi-tietoja-kerataan' | translate | async }}</div>
              <div class="dynamic-spacer"></div>
              <div>
                <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
                {{ 'lemonaid-sopimus-dialog.kyc.naita-tuntemistietoja' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
              <div>
                {{ 'lemonaid-sopimus-dialog.kyc.jos-muutoksia' | translate | async }}
              </div>
              <div class="dynamic-spacer"></div>
              <div class="dynamic-spacer"></div>
            </div>
            <div class="button-container">
              <button class="primarybutton" mat-button (click)="tallennaKyc()">{{ 'yleiset.jatka' | translate | async }}</button>
            </div>
          </form>
        </mat-step>
      }
      <mat-step [label]="'valmis'">
        <ng-template matStepLabel>
          <span (click)="saveCurrentStep($event)">
            {{ 'yleiset.valmis' | translate | async }}
          </span>
        </ng-template>
        <div class="teksti">
          <div class="dynamic-spacer"></div>
          @if (commonError()) {
            <div class="lemon-error">{{ commonError() }}</div>
          }
          <div class="dynamic-spacer"></div>
          <svg style="height: calc(76px + 1vw)" xmlns="http://www.w3.org/2000/svg" viewBox="4 4 22 22" fill="rgb(62, 203, 244)">
            <path d="M15 25.62A10.62 10.62 0 1 1 25.62 15 10.63 10.63 0 0 1 15 25.62ZM15 5.23A9.77 9.77 0 1 0 24.77 15 9.78 9.78 0 0 0 15 5.23Z"></path>
            <rect x="13.26" y="10.91" width="0.85" height="2.93"></rect>
            <rect x="15.89" y="10.91" width="0.85" height="2.93"></rect>
            <path d="M15 20.08a3.22 3.22 0 0 1-3.22-3.22h0.85a2.37 2.37 0 1 0 4.74 0h0.85A3.22 3.22 0 0 1 15 20.08Z"></path>
          </svg>
          <div class="light-blue-text otsikko">{{ 'yleiset.valmista' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          <div class="teksti-big">{{ 'lemonaid-sopimus-dialog.sopimus-hyvaksytty' | translate | async }}</div>
          <div class="dynamic-spacer"></div>
          <div class="dynamic-spacer"></div>
          @if (commonError()) {
            <div class="red-text common-error">{{ commonError() }}</div>
          }
          <div class="button-container">
            <button class="primarybutton" mat-button (click)="valmis()">{{ 'yleiset.ok' | translate | async }}</button>
          </div>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  }
</div>
